import http from 'services/http';

export interface StudyDayActivity {
  tests: number;
  focusMinutes: number;
}

export interface StudyStreak {
  current: number;
  best: number;
  today: StudyDayActivity;
  /** The last 14 Tashkent days, today last. */
  days: Array<{ date: string; active: boolean } & StudyDayActivity>;
}

export async function getStudyStreak(signal?: AbortSignal): Promise<StudyStreak> {
  const { data } = await http.request.get<{ data: StudyStreak }>('/api/portal/study/streak', { signal });
  return data.data;
}

export async function logFocusMinutes(minutes: number): Promise<{ focusMinutes: number }> {
  const { data } = await http.request.post<{ data: { focusMinutes: number } }>('/api/portal/study/focus', { minutes });
  return data.data;
}
